import React, { forwardRef, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  Slide,
  makeStyles,
} from "@material-ui/core";
import MaterialTable from "material-table";
import { connect } from "react-redux";
import tableIcons from "../../../components/commons/ConstantsMaterialTable";
import ErrorSnack from "../../../components/commons/ErrorSnack";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import LockIcon from "@mui/icons-material/Lock";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import UserAuthorities from "./UserAuthorities";
import ThunksUsers from "../../../redux/actions/thunks/OrgUsers";
import Local from "../../../redux/actions/local";
import PermissionsList from "./PermissionsList";

const useStyles = makeStyles({
  redIcon: {
    color: "red",
  },
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function UserList({
  message,
  getAllAuthorizations,
  allOrgUsers,
  deleteUser,
  getAllOrgUsers,
  selectUser,
  reset,
  response,
  resetUpadte,
  myUser,
  blockUser,
}) {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [agree, setAgree] = useState(false);
  const [deleteData, setDeleteData] = useState({});

  useEffect(async () => {
    await getAllAuthorizations();
    setLoading(false);
  }, []);

  const columns = [
    { title: "Email", field: "email", editable: "never", type: "email" },
    { title: "Full Name", field: "fullName", editable: "never" },
    {
      title: "Status",
      field: "block",
      editable: "never",
      render: (rowData) => (rowData.block ? "Blocked" : "Active"),
    },
    {
      title: "Permissions",
      field : "userAuthorities",
      render:(rowData)=>{
        return <PermissionsList list={rowData?.userAuthorities}/>
      },
    },
  ];
  const handleClose = () => {
    setAgree(false);
  };
  return (
    <>
      <MaterialTable
        icons={tableIcons}
        columns={columns}
        isLoading={loading}
        components={{
          Container: (props) => <Paper {...props} elevation={0} />,
        }}
        data={allOrgUsers.filter((item) => item.id != myUser.myId)}
        actions={[
          (rowData) => {
            return {
              icon: () =>
                rowData.block ? (
                  <LockIcon className={classes.redIcon} />
                ) : (
                  <LockOpenIcon />
                ),
              tooltip: rowData.block ? "Unblock User" : "Block User",
              onClick: async (event, rowData) => {
                await blockUser(rowData.id, rowData.block);
                await getAllOrgUsers();
              },
            };
          },
          {
            icon: () => <EditIcon />,
            tooltip: "Edit User",
            onClick: (event, rowData) => {
              selectUser(rowData);
            },
          },
          {
            icon: () => <DeleteIcon />,
            tooltip: "Delete User",
            onClick: async (event, rowData) => {
              setDeleteData(rowData);
              setAgree(true);
            },
          },
        ]}
        detailPanel={[
          {
            tooltip: "Authories Assigned",
            render: (rowData) => {
              return <UserAuthorities data={rowData} />;
            },
          },
        ]}
        options={{
          actionsColumnIndex: -1,
          detailPanelType: "single",
        }}
        title="Organization Users"
      />
      {!!message?.error && (
        <ErrorSnack errorMsg={message.error} reset={() => reset()} />
      )}
      {!!message?.success && (
        <ErrorSnack
          reset={() => reset()}
          success
          errorMsg={"User Deleted Successfully"}
        />
      )}
      {!!response?.error && (
        <ErrorSnack errorMsg={response.error} reset={() => resetUpadte()} />
      )}
      {!!response?.success && (
        <ErrorSnack
          reset={() => resetUpadte()}
          success
          errorMsg={"Authorizations Update Successfully"}
        />
      )}
      <Dialog
        open={agree}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Alert</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Are you sure to delete this user?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button
            onClick={async () => {
              await deleteUser(deleteData.id);
              await getAllOrgUsers();
              setAgree(false);
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

const mapState = (state) => ({
  message: state.orgUsers.deleteUser,
  allOrgUsers: state.orgUsers.allOrgUsers,
  response: state.orgUsers.updateUser,
  myUser: state.userInfo.user,
});

const mapDispatch = {
  getAllAuthorizations: ThunksUsers.getAllAuthorizations,
  deleteUser: ThunksUsers.deleteOrgUser,
  blockUser: ThunksUsers.blockUser,
  getAllOrgUsers: ThunksUsers.orgUsers,
  selectUser: Local.dialogActions.selectUser,
  reset: Local.deleteUser.reset,
  resetUpadte: Local.UpdateOrgUser.reset,
};

export default connect(mapState, mapDispatch)(UserList);
